import { Injectable, Inject } from 'ng-metadata/core';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {getAttributesMap, getDefaultScope,getUseIcelandicOrder, getVid, getTab} from '../../appConfig/appConfigForward'
import {SearchStateService} from '../searchState.service';
import {preventStateReload} from '../../infra/annotations';
import {SearchFieldsService} from '../search.fields.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {SharedSessionStorage} from "../../infra/sharedSessionStorage.service";
import {UserSessionManagerService} from "../../security/userSessionManager.service";
import {ActiveFacetsTransformationService} from "./facetsTransformation/activeFacetsTransformation.service";
import {InactiveFacetsTransformationService} from "./facetsTransformation/inactiveFacetsTransformation.service";
import {PartiallyTranslatedFieldsUtil} from '../../nddUtils/partiallyTranslatedFieldsUtil.service';
import {TranslationService} from "../../translate/translation.service";
import {ResultUtil} from "../../nddUtils/resultUtil.service";
import {MappingTablesCache} from '../../mappingTablesCache/mappingTablesCache.service';
import {AnalyticsUtils} from '../../nddUtils/analyticsUtils.service';

var angular:angular.IAngularStatic =  require('angular');
const isArray = require('lodash/isArray');
const flatten = require('lodash/flatten');
const remove = require('lodash/remove');
const he= require('he');
const memoize = require('lodash/memoize');
const some = require('lodash/some');
const forEach= require('lodash/forEach');
const findIndex= require('lodash/findIndex');
const sortBy = require('lodash/sortBy');
const pullAllWith = require('lodash/pullAllWith');
const isEqual = require('lodash/isEqual');
const isEmpty  = require('lodash/isEmpty');
const cloneDeep= require('lodash/cloneDeep');
const get= require('lodash/get');
const omit = require('lodash/omit');
const _escape = require('lodash/escape');

@Injectable()
export class FacetService{
	/* private members */
    private NO_ALWAYS : string = "no-always";
	private YES_ALWAYS: string = "yes-always";
	private NO_ENDUSER_SELECTION: string = "no-enduser-selection";
	private YES_ENDUSER_SELECTION: string = "yes-enduser-selection";
    private _searchInFulltextVal: string = "";
    private _searchInFulltext: boolean = false;       
    private vid: string = getVid();
	private results:any;
    public multiResults:any;
	private _displayedTypeFacet:any;
	private sortBy:any;
	private additionalData:any;
    public activeMultipleFacets: boolean = false;
    public activeRangeMultiFacet: boolean = false;
	private _pcAvailability: boolean = false;
    public stickyFacetsStorageKey: string="stickyFacets";
    private _facetLabelsMap: Object;
	private origLimits = [-1500,-1000,-500,1,500,1000,1500,1600,1700,1800,1900,1910,1920,1930,1940,1950];
    private diacriticsMappingForFacetAlphabeticSorting ={'ü':'ue','ä':'ae','ö':'oe'};
    private diacriticsMappingForIcelandicFacetAlphabeticSorting ={'å':'aa'};
	private scope2search: Map<string, string> = new Map<string, string>();


    private bundlePrefix = {
            lang : 'lang.',
            rtype : 'facets.facet.facet_rtype.',
            frbrgroupid : 'facets.facet.facet_frbrgroupid',
            tlevel : 'facets.facet.tlevel.',
            newrecords: 'facets.facet.facet_newrecords.',
            domain: '',
            library: '',
            other_libraries: '',
            data_source: 'fulldisplay.datasource.'
    };

    private viewInstitutionLibraries: string[];

	constructor(private configurationUtil: ConfigurationUtil,
				private searchStateService: SearchStateService,
				private searchFieldsService:SearchFieldsService,
				@Inject('$location') private $location: ng.ILocationService,
				@Inject('$translate') private $translate: ng.translate.ITranslateService,
				@Inject('$state') private $state: ng.ui.IStateService,
				@Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$q') private $q: ng.IQService,
                private sharedSessionStorageService: SharedSessionStorage,
                private mappingTablesCache: MappingTablesCache,
                private userSessionManager: UserSessionManagerService,
                private translationService:TranslationService,
                private activeFacetsTransformerService : ActiveFacetsTransformationService,
                private inactiveFacetsTransformationService: InactiveFacetsTransformationService,
                private partiallyTranslatedFieldsUtil : PartiallyTranslatedFieldsUtil,
                private resultUtil: ResultUtil,
                private analyticsUtils: AnalyticsUtils) {

		/* private members */
		this.results = [];
		this._displayedTypeFacet = {'creationdate' : 'range', 'searchcreationdate': 'range'};
		if(!this.configurationUtil.isSuprima()){
        	this.updateSearchInFulltext();
		} else{
			this.initScope2ftSearch();
		}
  
        this.sortBy = {
			'alpha_numeric': (facet)=> { //order by alpha numeric
                /* if value contains any dot (.), it means that no needed to translate it */
                // If display library name is enabled in the location facet, sorting will be based on library name + location name ,otherwise will be based on location name only
				let val = (facet.value.indexOf('.') > -1) ?
                    facet.value :  this.isDisplayLibraryNameLocationFacet(facet) ? this.getTranslatedLocationWithLibraryName(facet)
                    : $translate.instant(this.facetLabel(facet)) ;
                val =val.toLowerCase();
                //For icelandic or german discritics to be sorted by "phonebook" order
                if (getUseIcelandicOrder()) {
                    val = this.transformDiacriticsForSorting(val, this.diacriticsMappingForIcelandicFacetAlphabeticSorting);
                }
                else{
                    val = this.transformDiacriticsForSorting(val, this.diacriticsMappingForFacetAlphabeticSorting);
                }
				return val;
			},
			'by_size' : (facet) => { //order by facet size
				// In SuPrima, facets count comes as a String so just in case we are performing parsing.
				return -1 * parseInt(facet.count);
			},
			'by_number': (facet) =>{ //order by number (currently internal use for range facet)
				return parseInt(facet.value, 0);

			},
            'open_access': (facet) =>{ //PRM-38516 New UI - Open Access Facet should be displayed always at the bottom
                return 'open_access' === facet.value ? 1 : -1;
           }
		};

		let vm = this;
		this.additionalData = {
			'range' : (facetValues, minValue, maxValue)=> {
				facetValues = sortBy(facetValues,vm.sortBy.by_number);
				minValue = minValue ? parseInt(minValue) : parseInt(this.normalizeMinYear(facetValues[0].value), 0);
				maxValue = maxValue ? parseInt(maxValue) : parseInt(facetValues[facetValues.length - 1].value, 0);
				return {
					min:            minValue,
					max:            maxValue,
					selectedMin:    minValue,
					selectedMax:    maxValue,
                    step:           1};//Math.ceil((maxValue -  minValue) / 100)};
			}
		};
		if(this.configurationUtil.getBackendSystem() === 'suprima'){
			this.bundlePrefix.library = 'facets.facet.facet_library.';
			this.bundlePrefix.location_code = 'facets.facet.facet_location_code.';
            this.bundlePrefix.other_libraries = this.bundlePrefix.library;
		}
        this._facetLabelsMap = {};
        this.addFacetViewForInstitutionLibraries();
        if(this.configurationUtil.getViewInstitutionLibraries()){
        	this.viewInstitutionLibraries= Object.keys(this.configurationUtil.getViewInstitutionLibraries());
        }
	}

    get facetViews() {
    	if (this.configurationUtil.getFacetConfiguration())
        	return this.configurationUtil.getFacetConfiguration().facetview;
        else
        	return null;
    }

	/*this method checks if we have the instsort flag true in our facet_library group from configuration.
     If so adds another facet group configuration that will contain all libraries not belonging to our institution (with instsort= false) */
    private addFacetViewForInstitutionLibraries() {
    	let facetViews = this.facetViews;
    	if (facetViews){
	        let instSortIndex = findIndex(facetViews, (facetView) => {
	            return facetView.id === 'facet_library' && facetView.instsort
	        });
	        if (instSortIndex > -1){
	            let otherInstLibrariesFacetView = cloneDeep(facetViews[instSortIndex]);
	            otherInstLibrariesFacetView.instsort = false;
	            otherInstLibrariesFacetView.otherInstitutions= true;
	            facetViews.splice(instSortIndex + 1, 0, otherInstLibrariesFacetView);
	        }
        }
    }

    public facetSearch(params){
        params.facet = params.facet? flatten([params.facet]) : []; //make sure that we are working with an array of facets
        let searchParams= this.$stateParams;
        if(!searchParams['facet']){
            searchParams['facet']= [];
        }
        searchParams['facet']= flatten([searchParams['facet']]);
       	if(!searchParams['mfacet']){
            searchParams['mfacet']= [];
        }
        searchParams['mfacet']= flatten([searchParams['mfacet']]);
        let multiFacets = searchParams['mfacet'];
		if (params.sortby){
			searchParams['sortby']= params.sortby;
		}
		if (params.removeAll){
			if(this.facetsIncludeFrbr(searchParams['facet'])){
				searchParams = this.restorePrevSearchParams(searchParams);
			}
			else{
				searchParams['facet']= [];
                searchParams['mfacet']= [];
				searchParams['offset'] = 0;
				this.sharedSessionStorageService.removeItem('stickyFacets');
			}
		}
		if(params.facet.length > 0 && params.remove){
			if (this.facetsIncludeFrbr(params.facet)){
				searchParams= this.restorePrevSearchParams(searchParams);
			}
			else {
                let facetsToRemoveArray = params.facet;
				searchParams['facet'] = remove(searchParams['facet'], (facet) => !facetsToRemoveArray.includes(facet));
                searchParams['mfacet'] = remove(multiFacets, (mFacet) => !facetsToRemoveArray.includes(mFacet.slice(0, -2)));
				searchParams['offset'] = 0;
			}
		}

		let viewAllVersions = false;
		if(params.facet.length > 0 && !params.remove){
			searchParams['offset']= 0;
			if (this.facetsIncludeFrbr(params.facet)) {
				searchParams['facet'] = params.facet;
				searchParams['mfacet'] = [];
				viewAllVersions = true;
                searchParams['pfilter'] = [];
			}
			else {
				searchParams['facet'] = searchParams['facet'].concat(params.facet);
			}
        }
        if(params.mfacets && params.mfacets.length > 0 && !params.remove)
            searchParams['offset'] = 0;
        if(!viewAllVersions && params.mfacets) {
            forEach(params.mfacets, (multiFacet)=> {
				searchParams['mfacet'].push(multiFacet);
            });
        }
		if (!searchParams['query'] && searchParams['docid']) {
			let docid:string = searchParams['docid'];
			if(this.configurationUtil.isSuprima() && docid.startsWith('alma')){
                docid = docid.substr(4);
            }
			searchParams['query'] = 'any,contains,' + docid;
		}else if(!searchParams['query']){
            // when we come from collection discovery, we should display frbrs. the query is not important for that,
            // what we really need is the facet, so we construct a query just to display it in searchbox.
            searchParams['query'] = 'title,contains,' + params.title;
        }
		if (params.came_from){
            searchParams['came_from']= (params.came_from)
        }else{
            if(!get(params, 'remove', false) && !get(params, 'removeAll', false)){
                searchParams['came_from']= 'addFacet';
            }
        }
		return this.$state.go(this.facetSearchState(), searchParams  , {reload: this.facetSearchState()});
	}

    private facetsIncludeFrbr(facets) {
        return findIndex(facets, (facetString) => facetString.indexOf('frbrgroupid') !== -1) !== -1;
    }

    public frbrSearch(params, index: number){
        if(this.$state.current.name !== STATE_NAMES.CITATION_TRAILS){
            this.backupPreFrbrSearchParams(index);
        }	
        if(this.configurationUtil.getBriefResultConfiguration()){
        	params.sortby = this.configurationUtil.getBriefResultConfiguration().frbrsortby //when getting versions for frbr sort should be by date
        }
        this.facetSearch(params);

    }

    public updateSearchInFulltext(){
        if(!this.configurationUtil.isSuprima()){
        	this.searchInFulltextVal = this.getPrimoConfigRow();
		} else{
			let scope = this.getCurrentScope();
			this.searchInFulltextVal = this.scope2search.get(scope) || "";
		} 
        switch (this.searchInFulltextVal) {
            case this.YES_ALWAYS:
            case this.YES_ENDUSER_SELECTION:
                this.searchInFulltext = true;
                break;
            case this.NO_ALWAYS:
            case this.NO_ENDUSER_SELECTION:
                this.searchInFulltext = false;
                break;
            default:
                this.searchInFulltext = false;
        }
    }

	private initScope2ftSearch(){
		let tabsAndScopes2FtSearch = window.appConfig['primo-view']['cdi-ft-search-tab-scopes-map'] || new Map<string, string>();
		Object.keys(tabsAndScopes2FtSearch).forEach(tabName => {
	    	Object.keys(tabsAndScopes2FtSearch[tabName]).forEach( scopeName => {
			    this.scope2search.set(scopeName, tabsAndScopes2FtSearch[tabName][scopeName]);
			});
		});
	}
	
	public updateScope2FtMap(scope){
		this.scope2search.set(scope, this.searchInFulltext? this.YES_ENDUSER_SELECTION : this.NO_ENDUSER_SELECTION);
	}
	
	public setScope2search(scope, value){
		this.scope2search.set(scope, value);
	}

	private getCurrentScope(){
		return this.configurationUtil.getScopeName() || getDefaultScope();
	}
	
    private getPrimoConfigRow(){
        let configRow = this.getCdiFTsearchConfigFromMt();
        return (configRow.length > 0) ? configRow[0].target : "";
    }

    public isEndUserSelectionEnabledInPrimo(){
        return isEqual(this.YES_ENDUSER_SELECTION, this.searchInFulltextVal) || isEqual(this.NO_ENDUSER_SELECTION, this.searchInFulltextVal);
    }

    public getCdiFTsearchConfigFromMt() {
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VIEW_PROPERTIES, {source1: this.vid, source2: 'CDI_FullText_search'});
    }


    private allFacetsButFrbr(facets) {
        return flatten([facets]).filter(facet => facet && !facet.includes('frbrgroupid'));
    }

	private backupPreFrbrSearchParams(index:number) {
        this.searchFieldsService.prevSortBy = this.searchFieldsService.sortby;
        this.searchFieldsService.prevSortByAdvanced = this.searchFieldsService.prevSortBy;
		this.searchFieldsService.prevOffset = index? index-(index % this.resultUtil.updatedBulkSize) : 0;
		this.searchFieldsService.prevFacets = this.$stateParams['facet']? this.allFacetsButFrbr(this.$stateParams['facet']):[];
		this.searchFieldsService.prevMFacets = this.$stateParams['mfacet']? this.$stateParams['mfacet']:[];
        this.searchFieldsService.prevPFilters = this.$stateParams['pfilter']? this.$stateParams['pfilter']:[];
	}

	private restorePrevSearchParams(searchParams: any) {
		searchParams['sortby']= this.searchFieldsService.prevSortBy? this.searchFieldsService.prevSortBy: 'rank';
		searchParams['offset']= this.searchFieldsService.prevOffset? this.searchFieldsService.prevOffset: 0;
		searchParams['facet']= this.searchFieldsService.prevFacets? this.searchFieldsService.prevFacets: [];
		searchParams['mfacet']= this.searchFieldsService.prevMFacets? this.searchFieldsService.prevMFacets: [];
        searchParams['pfilter']= this.searchFieldsService.prevPFilters? this.searchFieldsService.prevPFilters: [];

		return searchParams;
	}

	getResults() {
		return this.results;
	}

	setResult(res) {
        this._facetLabelsMap = {};
        this.inactiveFacetsTransformationService.transformInactiveFacets(res).then((transformedRes)=>{
            res = transformedRes;
            this.userSessionManager.userDetailsDeferred.promise.then((response)=>{ //we need to wait for userDetails API to return so we can get the libraries for institution
                let librariesForUserInst= Object.keys(get(response, 'data.userInstitutionLibraries', {}));
                this.results = this.parseResults(res, librariesForUserInst);

            });
        });
    }

    public toggleMultiFacet(facet) {
        let idx = this.multiResults.indexOf(facet);
        if (idx > -1) {
            this.multiResults.splice(idx, 1);
            facet.checked = false;
        }
        else {
            facet.facetType = facet.facetType ? facet.facetType : 'include';
            this.multiResults.push(facet);
            facet.checked = true;
        }
        if (this.totalMultipleResults) {
            this.activeMultipleFacets = true;
        }
        else {
            this.activeMultipleFacets = false;
        }
    }

    public toggleMultiRangeFacet(rangeVal) {
        let changeCreationDate = this.activeRangeMultiFacet ? false : true;
        this.activeRangeMultiFacet = changeCreationDate;
        if (changeCreationDate) {
            let facet = {name: 'searchcreationdate', facetType: 'include', value: rangeVal, checked: true};
            this.multiResults.push(facet);
        }
        else {
            for (let i=0; i<this.multiResults.length; i++) {
                if (this.multiResults[i].name === 'searchcreationdate') {
                    this.multiResults.splice(i, 1);
                    break;
                }
            }
        }
        if (this.totalMultipleResults) {
            this.activeMultipleFacets = true;
        }
        else {
            this.activeMultipleFacets = false;
        }
    }

    public replaceMultiRangeFacet(rangeVal) {
        for (let i=0; i<this.multiResults.length; i++) {
            if (this.multiResults[i].name === 'searchcreationdate') {
                this.multiResults[i].value = rangeVal;
                break;
            }
        }
    }

    public totalMultipleResults(){
        return this.multiResults.length;
    }

    public toggleIncludeExclude(facet) {
        this.excludeIncludeUtil(facet);
        if (this.activeMultipleFacets) {
            if (!facet.checked) {
                this.toggleMultiFacet(facet);
            }
        }
        else if (facet.mergedFacets){
            this.toggleMultiFacet(facet);
            this.applyMultiFacets();
        }
        else {
            let facetType = facet.facetType ? facet.facetType : 'include';
            let facetString= facet.name+',' + facetType + ','+facet.value;
            this.facetSearch({facet: facetString});
        }
    }

    public excludeIncludeUtil(facet) {
        if (facet.facetType && facet.facetType === 'exclude') {
            facet.facetType = 'include';
        } else {
            facet.facetType = 'exclude';
        }
    }

    public clearMultiFacets() {
        forEach(this.multiResults, (facet)=> {
            if(facet.checked) {
                facet.checked=false;
                facet.facetType='include';
            }
        });
        this.multiResults = [];
        this.activeMultipleFacets = false;
        this.activeRangeMultiFacet = false;
    }

    public applyMultiFacets() {
        if (this.totalMultipleResults()) {
            let searchParams= this.$stateParams;
            let multiFacets = searchParams['mfacet'];
            if (multiFacets) {
                multiFacets = flatten([multiFacets]);
            }
            let groupIndexes = [];
            // Get all the group ids
            forEach(multiFacets, (mFacet)=> {
                let splitedGroup = mFacet.split(',');
                if (splitedGroup.length >= 4) {
                    let groupId = parseInt(splitedGroup[splitedGroup.length-1], 10);
                    if (groupId && groupId.toString().length <= 2) {
                        if (groupIndexes.indexOf(groupId) === -1) {
                            groupIndexes.push(groupId);
                        }
                    }
                }
            });
            let nextIndex = 1;
            let foundNextIdx = false;
            if (groupIndexes.length) {
                while (nextIndex < 100  && !foundNextIdx) {
                    if (groupIndexes.indexOf(nextIndex) === -1) {
                        foundNextIdx = true;
                    } else {
                        nextIndex++;
                    }
                }
            }
            let multiFacetsArr = [];
            forEach(this.multiResults, (multiFacet)=> {
                let facetString= multiFacet.name+','+multiFacet.facetType+','+multiFacet.value+','+nextIndex;
                multiFacetsArr.push(facetString);
                if (multiFacet.mergedFacets){
                    for(let mergedFacet of multiFacet.mergedFacets){
                        let facetString = multiFacet.name+','+multiFacet.facetType+','+mergedFacet.value+','+nextIndex;
                        multiFacetsArr.push(facetString);
                    }
                }
            });
            this.facetSearch({mfacets: multiFacetsArr});
        }
    }

	private filterEmpty(e) {
		return e.name;
	}

	private parseItem(res, selectedFacets, item, minValue, maxValue, librariesForUserInst) {
		let filtered = res.filter((obj)=> {
			return obj.name ===  item.id.replace('facet_', '');
		});

		if (filtered.length === 0)  {
			return {};
		}

		let cur = filtered[0]; //current single result filtered by configutation
        let curValues= cur.values;
        let name= cur.name;

		let selectedFacetsOfCurTypeNames = (selectedFacets.filter((facet)=>facet.name === cur.name)).map((curFacet)=>curFacet.value);

        // Hiding already selected facets from the facets list
        curValues = (cur.values).filter((facet) => {
            // direct match, e.g. facet.value === "a"
            const directMatch = selectedFacetsOfCurTypeNames.includes(facet.value);

            // DEI note match, e.g. facet.value === "$$DEINOTE a"
            const deiMatch = selectedFacetsOfCurTypeNames.some(name =>
                facet.value === `$$DEINOTE ${name}`
            );

            return !directMatch && !deiMatch;
        });

		if (curValues.length === 0)  {
			return {};
		}

        if (cur.name === 'library'){
            curValues= this.filterLibraryValuesByInstitution(curValues, item.instsort, item.otherInstitutions, item.viewinstsort, librariesForUserInst);
            if (item.instsort){
                name= 'library_myinstitution';
            }
            if (item.otherInstitutions){
                name= 'library_otherinstitution';
            }
        }

		let convertFacetWithName = angular.bind(this, this.convertFacet , cur.name);
		/* sorting */
		curValues = curValues.map(convertFacetWithName);

		let sort  = angular.isObject(item.sort) ? item.sort._string : item.sort;

		if (this.sortBy[sort]) {
            if (this.$translate.use().startsWith("zh") && sort === 'alpha_numeric'){
                curValues = this.localeCompareSortObjectArray(curValues,"zh", this.sortBy[sort]);
            }
            else if (getUseIcelandicOrder() && sort === 'alpha_numeric'){
                let icelandicCharsOrdered = "aábcdðeféghiíjklmnoóøpqrstuúvwxyýzþæö"
                try {
                    curValues = this.compareSortObjectArrayBySortedArray(curValues, icelandicCharsOrdered, this.sortBy[sort], "is")
                }
                catch (e) {
                    curValues = this.localeCompareSortObjectArray(curValues,"is", this.sortBy[sort]);
                }
            }
            else {
                curValues = sortBy(curValues,this.sortBy[sort]);
            }
        }

        curValues.forEach((facet)=>{this.addPartialTranslation(facet, item.useTranslations)});

		let result = {
			name:   			name,	//name of facet group (i.e. Creator)
			limitCount:			item.count, //limited displayed count as configured in configuration
			values: 			curValues,	//facet values
			additionalData: 	this.additionalData[this._displayedTypeFacet[cur.name]] ?
				this.additionalData[this._displayedTypeFacet[cur.name]](curValues, minValue, maxValue) : {},
			displayedType:		this._displayedTypeFacet[cur.name] ?
				this._displayedTypeFacet[cur.name] : 'exact',

			//UI
			displayedCount:		item.count > 0 ? item.count : curValues.length, //count to display, can be limitCount or values.length
			facetGroupCollapsed: item.count === 0,
			useTranslations: item.useTranslations
		};

		if (item.instsort){
		    result['labelParam']= this.$translate.instant(this.userSessionManager.getUserInstitutionCode());
        }

		return result;

    }
    
    private addPartialTranslation(facet, useTranslations){
        if (this.partiallyTranslatedFieldsUtil.isPartiallyTranslated(facet.value)){
            facet.isPartialyTranslatedFacet = true;
            this.partiallyTranslatedFieldsUtil.handlePartiallyTranslatedFacet(facet, useTranslations).then((translatedFacetValue)=>{
                facet.partaillyTranslatedValue = translatedFacetValue;
            });
        }
    }

    private filterLibraryValuesByInstitution(curValues: any, userInstSort: boolean, otherInstitutions: any, viewInstSort: boolean, librariesForUserInst: [string]) {
        return curValues.filter((value)=>{
            if (userInstSort){
                return librariesForUserInst.indexOf(value.value) > -1;
            }
            else if (otherInstitutions){
                return librariesForUserInst.indexOf(value.value) === -1;
            }
            else if (viewInstSort){
                return this.viewInstitutionLibraries.indexOf(value.value) > -1;
            }
            else {
                return true;
            }
        });
    }

	parseResults(res, librariesForUserInst) {

		let facets = this.searchStateService.getSearchObject().facets;

		let selectedMinYear = undefined;
		let selectedMaxYear = undefined;

        forEach(facets, (facet) => {

            if(facet.name === 'searchcreationdate' && facet.value) {

                let splittedValue = facet.value.split('|,|');
                let curSelectedMin = facet.minValue;
                let curSelectedMax = facet.maxValue;

                if (splittedValue && splittedValue.length === 2) {
                    curSelectedMin = splittedValue[0];
                    curSelectedMax = splittedValue[1];
                }

                if (!selectedMinYear || selectedMinYear < curSelectedMin) {
                    selectedMinYear = curSelectedMin;
                }

                if (!selectedMaxYear || selectedMaxYear > curSelectedMax) {
                    selectedMaxYear = curSelectedMax;
                }
            }
        });
		return this.facetViews
			.map((value, index, array1) => {
		        return this.parseItem(res, facets, value, selectedMinYear, selectedMaxYear, librariesForUserInst)
		})
            .filter(this.filterEmpty);
	}

	convertFacet(name, cur) {
		let facet = {
			name : name,
			value : cur.value,
			count : cur.count,
            maxCount : cur.maxCount,
            label : cur.label

        };
		if (cur.mergedFacets){
		    facet['mergedFacets'] = cur.mergedFacets;
        }
        if(cur.label){
            let map = this._facetLabelsMap[name];
            if(!map){
                map = {};
                this._facetLabelsMap[name] = map;
            }
            map[cur.value] = cur.label;
        }
        return facet;
    }

	private  isFacetExists(facets, obj) {
		return facets.filter((cur)=> { return obj.value === cur.value;}).length > 0;

	}

	get displayedTypeFacet(){
		return this._displayedTypeFacet;
	}

	getRangeFacetValue(minYear, maxYear){
		return minYear +'|,|'+ maxYear;
	}

	getFacetLabel(name, displayedType,value){
        return this.$q((resolve, reject)=>{
            if(name==='frbrgroupid'){
                resolve(name);
            }
            if (displayedType ==='range'){
                this.getYearLabelValue(value).then((translation)=>{
                    resolve(translation);
                });
            } else{
                resolve(value);
            }
        });
    }

    private getYearLabelValue(value) {
        return this.$q((resolve, reject)=>{
            if (value === -1) {
                resolve(value);
            }
            let prefix = 'nui.' + value.substr(0, value.lastIndexOf('.'));
            let afterTranslate;
            this.$translate(prefix).then((translation)=> {
                afterTranslate = translation;
                resolve(afterTranslate + ' ');
            });

        });
    }

	public getRangeFacetLabelFromValue(facetValue){
        let minMaxArr = facetValue.split('|,|');
        if (minMaxArr.length < 2) {
            return facetValue;
        }
		return minMaxArr[0] + '-' + minMaxArr[1] ;
	}

	private normalizeMinYear(minYear) {
        if(!this.configurationUtil.isSuprima()){
	    	let index = this.getIndex(parseInt(minYear,10));
		    if(index > 0){
		    	return this.origLimits[index - 1];
		    }
        }
		return minYear;
	}

	private getIndex(date) {
		for (let j = 0; j < this.origLimits.length; j++) {
			if (date <= this.origLimits[j]) {
				return j;
			}
		}
		return -1;
	}

    // Indication if you are on "PC" scope ("Include Results with no full-text" flag is off)
    // Here only "CDI" checked --> AVAILABLE_ONLY
	public showPcAvailabilityForScope = memoize((scope)=>{
        if(!scope){
            scope = getDefaultScope();
        }
		let map = window.appConfig['primo-view']['pc-availability-tab-scopes-map'];
		return some(Object.keys(map), (value) => map[value][scope] === 'AVAILABLE_ONLY');
	});

    // Indication if you are on "PC" scope ("Include Results with no full-text" flag can be on or off)
    // if only "CDI" checked --> AVAILABLE_ONLY
    // if "CDI" checked & "Include Results with no full-text" checked --> INCLUDE_NO_FULL_TEXT
    public showSearchInFullTextForScope = memoize((scope)=>{
		let map = window.appConfig['primo-view']['pc-availability-tab-scopes-map'];
        return some(Object.keys(map), (value) => map[value][scope] === 'AVAILABLE_ONLY' || map[value][scope] === 'INCLUDE_NO_FULL_TEXT');
	});


	get pcAvailability(){
		return this._pcAvailability;
	}

	set pcAvailability(newVal){
		this._pcAvailability= newVal;
	}

    get searchInFulltext(){
		return this._searchInFulltext;
	}

	set searchInFulltext(bool){
		this._searchInFulltext = bool;
	}

    get searchInFulltextVal(){
		return this._searchInFulltextVal;
	}

	set searchInFulltextVal(str){
		this._searchInFulltextVal = str;
	}

	private facetSearchState(){
		if (this.$state.current.name === STATE_NAMES.FULL_DISPLAY || this.$state.current.name === STATE_NAMES.CITATION_TRAILS || this.$state.current.name === STATE_NAMES.COLLECTION_DISCOVERY) {
            return STATE_NAMES.SEARCH;
        }
        return this.$state.current.name;
	}

    public facetLabel(facet) {
        let facetLabelValue = this.getFacetLabelValue(facet.name,facet.value);
        if(facetLabelValue){
            return facetLabelValue;
        }
        let prefix = this.bundlePrefix[facet.name];
        if (!angular.isDefined(prefix)) {
            prefix = 'facets.facet.facet_'+facet.name+'.';
        }

        let displayValue = facet.name !== 'tlevel' ? facet.displayValue || facet.value : facet.value;

        if (displayValue.endsWith(".")) {
        	displayValue = displayValue.slice(0, -1);
        }

        if(facet.partaillyTranslatedValue){
            displayValue = facet.partaillyTranslatedValue;
        }

        return (facet.name !== 'frbrgroupid')  ? prefix + displayValue : prefix;
    }

     public getFacetDefaultValue(facet) {
        if (this.displayedTypeFacet[facet.name] === 'range') {
            let rangeFacetValue = this.getRangeFacetLabelFromValue(facet.displayValue);
            if (rangeFacetValue === facet.displayValue) {
                return rangeFacetValue;
            }
            return facet.label + rangeFacetValue;
        }
        return (facet.partaillyTranslatedValue || facet.displayValue || facet.value);
     }
    /*
    saves the facet to the local storage,
    in order to use it during the whole session
    */
    public addStickyFacet(facet){
        facet.persistent = true;
        facet.operation = 'add';
        this.addLockedIndicationOfFacetInUrl(facet);
        let stickyFacetsArray = this.getStickyFacetsFromPersistentStorage();
        
        // Add the facet to session storage only if it's not already exists there (e.g. after page reload)
        if(!this.isStickyFacetAlreadyExistsInArray(facet, stickyFacetsArray)){
	        let stickyFacetsToAdd = this.expandFacetToArray(facet);
	        stickyFacetsArray = stickyFacetsArray.concat(stickyFacetsToAdd);
	        this.sharedSessionStorageService.setItem(this.stickyFacetsStorageKey,JSON.stringify(stickyFacetsArray));
        }
    }
    
    private isStickyFacetAlreadyExistsInArray(facet, stickyFacetsArray){
		// verify that facet not exists in the facets array (e.g. after page reload)       
        let stickyFacetAlreadyExistsInArray = false;
		forEach(stickyFacetsArray, (stickyFacet)=> {
			if(facet && stickyFacet && 
				stickyFacet.name  === facet.name &&
				stickyFacet.type  === facet.type &&
				stickyFacet.value === facet.value ){

				stickyFacetAlreadyExistsInArray = true;	
				return true;
			}
        });

        return stickyFacetAlreadyExistsInArray;
	}
	
    
    @preventStateReload
    private addLockedIndicationOfFacetInUrl(stickyFacet){
        this.replaceUrlFacetsParameters(stickyFacet, true);
    }
    
    @preventStateReload
    private removeLockedIndicationOfFacetFromUrl(stickyFacet){
        this.replaceUrlFacetsParameters(stickyFacet, false);
    }
    
    private getFacetsAndMfacetsArray(){
      
        let searchUrlParams = this.$location.search();
        
        // Make sure to define empty array if the parameters are undefined.
        if(!searchUrlParams['facet']){
            searchUrlParams['facet']= [];
        }
        if(!searchUrlParams['mfacet']){
            searchUrlParams['mfacet']= [];
        }

        // Make sure the facet array will be an array in order to create concatenated array of facets and mfacets
        let facetsArray = isArray(searchUrlParams['facet']) ? searchUrlParams['facet'] : [searchUrlParams['facet']];
        let mfacetsArray = isArray(searchUrlParams['mfacet']) ? searchUrlParams['mfacet'] : [searchUrlParams['mfacet']];
        return (facetsArray).concat(mfacetsArray);
    }
    
    private replaceUrlFacetsParameters(stickyFacet, locked: boolean){
        let facetsAndMfacetsArray = this.getFacetsAndMfacetsArray();
        let searchUrlParams = this.$location.search();  // get again the updated search URL parameters
        let stickyFacetStr = this.getStickyFacetStr(stickyFacet, locked);
        
        facetsAndMfacetsArray.forEach((facet) => {
            // Find new facet / mfacet which locked / unlocked by user
            if(facet === stickyFacetStr){
                let stickyFacetStrToReplace = (locked) ? facet.concat(',lk') : facet.replace(',lk', '');
                
                // Find index in array or parameter of the facet / mfacet we want to replace in URL
                let fkey = stickyFacet.isMultiFacet ? 'mfacet' : 'facet';
                if(searchUrlParams[fkey]){
                    if(isArray(searchUrlParams[fkey])){
                        let index = searchUrlParams[fkey].indexOf(facet);
                        searchUrlParams[fkey][index] = stickyFacetStrToReplace;
                    }else{
                        searchUrlParams[fkey] = stickyFacetStrToReplace;
                    }
                    this.$location.search(fkey, searchUrlParams[fkey]);
                    this.$stateParams[fkey] = searchUrlParams[fkey];
                }
            }
        });
    }
    
    private getStickyFacetStr(stickyFacet, locked: boolean){
        let stickyFacetStr = stickyFacet.name+',' + stickyFacet.type + ','+stickyFacet.value;
        if(stickyFacet.isMultiFacet){
            stickyFacetStr = stickyFacetStr.concat(',' + stickyFacet.multiFacetGroupId);
        }
        return (locked) ? stickyFacetStr : stickyFacetStr.concat(',lk');
    }

    //converts facet into an array of facets. if facet includes merged facets it flattens them all into the returned array
    private expandFacetToArray(facet) {
        let facetsArray = [];
        if (facet.mergedFacets) {
            facetsArray = facetsArray.concat(facet.mergedFacets);
            facet = omit(facet, 'mergedFacets');
        }
        facetsArray.push(facet);
        return facetsArray;
    }

    /*
        removes the facet from the local storage,
        in order not to use it during the whole session
        */
    public removeStickyFacet(facet){
        facet.persistent = false;
        this.removeLockedIndicationOfFacetFromUrl(facet);
        let stickyFacetsArray = this.getStickyFacetsFromPersistentStorage();
        let facetsToRemove = this.expandFacetToArray(facet);
        remove(stickyFacetsArray, (stickyFacet)=>
            findIndex(facetsToRemove, (facetToRemove)=> this.isFacetEqual(stickyFacet,facetToRemove)) > -1
        );
        this.sharedSessionStorageService.setItem(this.stickyFacetsStorageKey,JSON.stringify(stickyFacetsArray));
    }

    /*
    returns the sticky facets from the local storage,
    in order to use it during the whole session
    */
    public getStickyFacets(){
        if (this.isFrbrSearch()) {
            return [];
        }
        return this.getStickyFacetsFromPersistentStorage();
    }

    private getStickyFacetsFromPersistentStorage() {
        let stickyFacetsString = this.sharedSessionStorageService.getItem(this.stickyFacetsStorageKey);
        let stickyFacetsArray;
        if (isEmpty(stickyFacetsString)) {
            stickyFacetsArray = [];
        }
        else {
            stickyFacetsArray = JSON.parse(stickyFacetsString);
        }
        return stickyFacetsArray;
    }

    /*
        returns true if the facets contains a "list all versions" facet,
        which is true on a frbr search.
        */
    public isFrbrSearch(){
        let facetsList = this.$stateParams['facet'];
        if (facetsList !== undefined && facetsList) {
            facetsList = flatten([facetsList]);
            if (!facetsList.includes(undefined)) {
                for (let i=0; i<facetsList.length; i++) {
                    if (facetsList[i].indexOf('frbrgroupid') !== -1) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    /*
    returns true if facet1 is Equal to facet2
    */
    public isFacetEqual(facet1,facet2){
        if( isEmpty(facet1) || isEmpty(facet2) ){
            return false;
        }
        return (facet1.type == facet2.type)
                  && (facet1.name == facet2.name)
                  && (facet1.value == facet2.value)
    }

    get facetLabelsMap(): Object {
        return this._facetLabelsMap;
     }


    public getFacetLabelValue(facetName, facetValue){
        if(this._facetLabelsMap[facetName]){
            return this._facetLabelsMap[facetName][facetValue];
        }
     }

     public transformActiveFacets(facetsList){
        let transformedActiveFacets =  this.activeFacetsTransformerService.transformActiveFacets(facetsList);
        transformedActiveFacets.forEach(transformedActiveFacet => {
            this.addPartialTranslation(transformedActiveFacet, transformedActiveFacet.useTranslation);
        });
        return transformedActiveFacets;
     }


    public  getTranslatedFacetGroupName(facetGroupName) {
        if (!this.$translate.isReady()){
            return undefined;
        }
        return this.translationService.translateInstantWithDefault(`facets.facet.facet_${facetGroupName}`,facetGroupName);
    }

    public removeNotRelevantChars(facet:string):string{
        let $$8RegEx= /\$\$8\s*(.){3}/g;
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            $$8RegEx= /\$\$8\s*(.){2}/g;
        }
        return facet.replace($$8RegEx, '');
    }

    public subStringBeforeSecondDash(str){
        const dashString = '–';
        let firstIndexOfDash = str.indexOf(dashString);
        let secondIndexOfDash = str.indexOf(dashString, firstIndexOfDash + 1);
        return str.substring(0,secondIndexOfDash);
    }
    
    public getFacetTitleTranslated(facet, facetGroup){
        if (!this.$translate.isReady()){
            return undefined;
        }
        let default_txt = this.removeNotRelevantChars(facet.displayValue || facet.value);
        if(facet.isPartialyTranslatedFacet){
            return facet.partaillyTranslatedValue;
        }
        if (facetGroup.useTranslations) {
            return this.translationService.translateInstantWithDefault(facet.value.toLowerCase(),default_txt);
        }
        if(this.isDisplayLibraryNameLocationFacet(facetGroup)){
            return this.getTranslatedLocationWithLibraryName(facet);
        }
       return this.removeCharsFromLabel(this.translationService.translateInstantWithDefault(this.removeNotRelevantChars(this.facetLabel(facet)),default_txt));

    }

    private removeCharsFromLabel(facetTitleTranslated: string) {
        if(this.configurationUtil.isSuprima() && facetTitleTranslated){
            const charsToRemoveFromLabel = /[<>]/g;
            return facetTitleTranslated.replace(charsToRemoveFromLabel, '');
        }
        else{
            return facetTitleTranslated;
        }         
    }

    private isDisplayLibraryNameLocationFacet(facetGroup){
        return this.configurationUtil.getBackendSystem() === 'suprima' && facetGroup.name === 'location_code' && getAttributesMap()['displayLibraryNameLocationFacet'];
    }

    private getTranslatedLocationWithLibraryName(facet){
        if (!this.$translate.isReady()){
            return undefined;
        }
        let default_txt = this.removeNotRelevantChars(facet.displayValue || facet.value);
        return `${this.translationService.translateInstantWithDefault(this.removeNotRelevantChars(this.createlibraryNameLabelFromLocationFacet(facet)),default_txt)} - ${this.translationService.translateInstantWithDefault(this.removeNotRelevantChars(this.facetLabel(facet)),default_txt)}`;
    }

    private createlibraryNameLabelFromLocationFacet(facet){
        let locationLabel = `${this.bundlePrefix.library}${facet.value}`
        let libraryNameLabel = this.subStringBeforeSecondDash(locationLabel);
        return libraryNameLabel;
    }

    private transformDiacriticsForSorting(val: string,diacriticsMappingForFacetAlphabeticSorting:object){
       for (let diacritic in diacriticsMappingForFacetAlphabeticSorting) {
         let diacriticTransformForSort = diacriticsMappingForFacetAlphabeticSorting[diacritic];
         let diacriticRegexp = new RegExp(diacritic, 'g');
         val = val.replace(diacriticRegexp, diacriticTransformForSort);
      }
      return val;
   }

   public localeCompareSortObjectArray(array:Array<object>, lang:string, getSortByValue:(a:object) => string){
    return array.sort(
        function compareFunction(param1, param2) {
            return getSortByValue(param1).localeCompare(getSortByValue(param2),lang);
        }
    );
   }

    public compareSortObjectArrayBySortedArray
    (array:Array<object>, sortedArray:string, getSortByValue:(a:object) => string,lang:string) {
        return array.sort(
            function compareFunction(param1, param2) {
                for (let i = 0; i < 100; i++) {
                    if (getSortByValue(param1).length > i && getSortByValue(param2).length > i) {
                        if (sortedArray.indexOf(getSortByValue(param1)[i])!=-1 && sortedArray.indexOf(getSortByValue(param2)[i])!= -1){
                            if ((sortedArray.indexOf(getSortByValue(param1)[i]) - sortedArray.indexOf(getSortByValue(param2)[i])) === 0) {
                                continue;
                            } else {
                                return sortedArray.indexOf(getSortByValue(param1)[i]) - sortedArray.indexOf(getSortByValue(param2)[i]);
                            }
                        }
                        else{
                            if (getSortByValue(param1)[i]===getSortByValue(param2)[i]){
                                continue;
                            }
                            return getSortByValue(param1)[i].localeCompare(getSortByValue(param2)[i], lang);
                        }
                    } else {
                        return getSortByValue(param1).length-getSortByValue(param2).length;
                    }
                }
                return 0;
            }
        );
    }

    public sendAnalytics(eventName, payload) {
        this.analyticsUtils.trackUsage(eventName, payload);
    }

    public capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facet.service.ts